import api from '../api';
import { normalizeUrl } from '../../utils/url';
import { USE_LIVE_SEARCH_MOCKS } from '../forms/formMockConfig';
import { getFieldSuggestionsMock } from '../../mocks/mock-field-suggestions';

/**
 * GET field suggestions (autocomplete on existing column values).
 * Appends only &search= (and optional &limit=) to the URL provided by the form config.
 * @param {string} suggestionsUrl - URL from field.text.suggestionsUrl
 * @param {string} search - Text typed by the user
 * @param {number} [limit] - Optional max number of suggestions
 * @returns {Promise<string[]>}
 */
export const getFieldSuggestions = async (suggestionsUrl, search, limit) => {
  if (!suggestionsUrl) {
    throw new Error('suggestionsUrl is required');
  }

  if (USE_LIVE_SEARCH_MOCKS) {
    return getFieldSuggestionsMock(suggestionsUrl, search, limit);
  }

  let url = `${normalizeUrl(suggestionsUrl)}&search=${encodeURIComponent(search)}`;
  if (limit != null) {
    url += `&limit=${encodeURIComponent(String(limit))}`;
  }

  const response = await api.get(url);

  if (response.status === 204) {
    return [];
  }

  return response.data?.suggestions ?? [];
};
